///*
//* ------------------------------------------------------------------------
//* Variables
//* ------------------------------------------------------------------------
//*/

//var feedbackHandlingForm = $('#feedbackHandlingForm'),
//    feedbackButtons = feedbackHandlingForm.find('input[type="radio"]'),
//    feedbackHandlingReplies = $('.feedback-handling__reply');

///*
//* ------------------------------------------------------------------------
//* Function definitions
//* ------------------------------------------------------------------------
//*/

//// Show or hide reply based on answer to "Is this content helpful?"
//function showHideFeedbackReply() {
//    var thisId = $(this).attr('id').capitalize();
//    feedbackHandlingReplies.addClass('hidden');
//    $('#answered' + thisId).removeClass('hidden');
//}

///*
//* ------------------------------------------------------------------------
//* Runs when HTML is ready
//* ------------------------------------------------------------------------
//*/

//$(function () {
//    feedbackButtons.on('click', showHideFeedbackReply);
//});
